import { useCallback, useState } from "react";
import React from "react";
import ReactDOM from "react-dom";
import { Box, Link, ThemeProvider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { groopTheme } from "../../styles/MaterialGroopTheme";
import { sharingAllStore, useSharingAll } from "./Store/SharingAllStore";
import { AiLoadingComponent } from "./AiLoadingComponent";

interface AllInsightsProcessorProps {
  extractedDataModelCount: number;
  groopId: string;
  returnUri: string;
}

export const AllInsightsManager = (props: AllInsightsProcessorProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const sharingAll = useSharingAll();

  const toggleSharingAll = () => {
    sharingAllStore.setSharingAll(!sharingAll);
  };

  const dismissAll = useCallback(() => {
    setLoading(true);
    window.location.href = props.returnUri;
  }, [props.returnUri]);

  const useStyles = makeStyles(() => ({
    allLink: {
      color: groopTheme.palette.primary.dark,
    },
  }));

  const classes = useStyles();

  return (
    <>
      <ThemeProvider theme={groopTheme}>
        <Box color="primary.dark">
          {props.extractedDataModelCount > 1 && (
            <>
              {sharingAll && (
                <AiLoadingComponent
                  loading={true}
                  showAiIcon={false}
                  clicked={() => null}
                />
              )}
              {!sharingAll && (
                <>
                  <Link
                    className={
                      loading
                        ? `${classes.allLink} cursor-not-allowed underline text-sm`
                        : `${classes.allLink} cursor-pointer underline text-sm`
                    }
                    onClick={() => {
                      toggleSharingAll();
                    }}
                  >
                    Share all
                  </Link>{" "}
                  <span className="text-sm">
                    {props.extractedDataModelCount} insights |{" "}
                  </span>
                  <Link
                    className={
                      loading
                        ? `${classes.allLink} cursor-not-allowed underline text-sm`
                        : `${classes.allLink} cursor-pointer underline text-sm`
                    }
                    onClick={() => dismissAll()}
                  >
                    Dismiss all
                  </Link>{" "}
                  <span className="text-sm">
                    {props.extractedDataModelCount} insights
                  </span>
                </>
              )}
            </>
          )}
        </Box>
      </ThemeProvider>
    </>
  );
};

const allExternalDataToGroopit = document.querySelector(
  ".all-external-data-to-groopit",
) as HTMLElement;

if (allExternalDataToGroopit) {
  ReactDOM.render(
    <AllInsightsManager
      extractedDataModelCount={
        allExternalDataToGroopit.dataset
          .extractedDataModelCount as unknown as number
      }
      groopId={allExternalDataToGroopit.dataset.groopId as string}
      returnUri={allExternalDataToGroopit.dataset.returnUri as string}
    />,
    allExternalDataToGroopit,
  );
}
